import { Accordion, AccordionDetails, AccordionSummary, Paper, Stack, Typography } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

export function ProfileAccordion({ icon, title, children }: { icon: React.ReactNode; title: string; children: React.ReactNode }) {
  return (
    <Paper elevation={0} sx={{ borderRadius: 3, overflow: 'hidden', boxShadow: '0 12px 40px rgba(25,28,29,0.06)' }}>
      <Accordion
        elevation={0}
        disableGutters
        sx={{
          backgroundColor: 'transparent',
          '&:before': { display: 'none' },
          '& .MuiAccordionSummary-root': { px: 4, minHeight: 64 },
          '& .MuiAccordionSummary-content': { my: 2.5 },
          '& .MuiAccordionDetails-root': { px: 4, pb: 4 },
        }}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: 'text.disabled' }} />}>
          <Stack direction="row" alignItems="center" spacing={1}>
            {icon}
            <Typography variant="h6" sx={{ fontWeight: 700, letterSpacing: '-0.01em' }}>
              {title}
            </Typography>
          </Stack>
        </AccordionSummary>
        <AccordionDetails>{children}</AccordionDetails>
      </Accordion>
    </Paper>
  )
}
